import PropTypes from 'prop-types'
import React from 'react'
import { Text } from '@chakra-ui/react'
import SvgIcon from 'src/components/SvgIcon'
import { isEmpty } from 'src/utils/helpers'
import styles from './GoogleMapPlaceRating.module.less'

const GoogleMapPlaceRating = ({ place }) => {
  if (isEmpty(place)) {
    return ''
  }

  /**
   * Get empty, full or half of the star based on rating number.
   *
   * @param {number} rawRating Place rating
   * @param {number} star 1 to 5
   * @return {string} ["Star"|"StarHalf"|"StarEmpty"]
   */
  const getStarIcon = (rawRating, star) => {
    const ratingSafe = rawRating > 0 ? rawRating : 0
    if (ratingSafe >= star) {
      return 'Star'
    }
    const ratingDecimal = (ratingSafe % 1).toFixed(1)
    if (Math.ceil(ratingSafe) === star && ratingDecimal >= 0.3) {
      return 'StarHalf'
    }
    return 'StarEmpty'
  }

  return (
    <div className={styles.rating}>
      <Text fontSize={'10px'}>{place.rating || 0}</Text>
      <Text fontSize={'10px'} className={styles.stars}>
        {[1, 2, 3, 4, 5].map(star => (
          <SvgIcon
            type={getStarIcon(place.rating, star)}
            className={styles.star}
            key={`star-${star}`}
          />
        ))}
      </Text>
      <Text fontSize={'10px'}>({place.user_ratings_total || 0})</Text>
    </div>
  )
}

GoogleMapPlaceRating.propTypes = {
  place: PropTypes.object.isRequired,
}

export default GoogleMapPlaceRating
